// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
} 

/* body{
   background-color: antiquewhite; 
} */
header{
  color: grey;
  display: flex;
  /* background-color: whitesmoke !important; */
  /* height: 0%; */
 
  flex-direction: column;
  align-items: center;
}
.modal-header{
  justify-content: center;
}
.modal-body{
  text-align: center;
}
.bodyApp {
  display: flex;
  /* width: 100vw; */
  height: 55vh;
  align-items: center;
  justify-content: center;
}
.header{
  margin-top: 5%;
}
.title{
  font-size: 40px;
  font-family: inherit;
  font-weight: 900;
}
.Ocean {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 90%;
  height: 90%;
  border-radius: 0px 10px 10px 0px;
  background-color: #B3E5FC !important;
  overflow: hidden;
  border-radius: 50px;
}
.Ocean_disabled {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 90%;
  height: 90%;
  border-radius: 0px 10px 10px 0px;
  background-color: #B3E5FC !important;
  overflow: hidden;
  border-radius: 50px;
}

.Button:disabled{
  background-color: gray;
}
.Level100{
  transform: translateY(-1px);
  background: rgb(128, 0, 0) !important;
  /* padding: 0px; */
  /* border-radius: 50px 50px 0px 0px; */
  /* margin: 0px; */
 
  border: none;
  /* box-shadow: grey 0px 0px 0px 5px; */
  /* margin-top: -10%; */
  color: white;
  font-size: 50px;
  font-family: unset;
  font-weight: bolder;
  justify-content: center;
  /* display: flex; */
  align-items: center;
}
.Level{
    transform: translateY(-1px);
    background: forestgreen !important;
    /* padding: 0px; */
    /* border-radius: 50px 50px 0px 0px; */
    /* margin: 0px; */
   
    border: none;
    /* box-shadow: grey 0px 0px 0px 5px; */
    /* margin-top: -10%; */
    color: white;
    font-size: 50px;
    font-family: unset;
    font-weight: bolder;
    justify-content: center;
    /* display: flex; */
    align-items: center;
}
.Level_disabled{
  transform: translateY(-1px);
  background: grey !important;
  /* padding: 0px; */
  /* border-radius: 50px 50px 0px 0px; */
  /* margin: 0px; */
 
  border: none;
  /* box-shadow: grey 0px 0px 0px 5px; */
  /* margin-top: -10%; */
  color: white;
  font-size: 50px;
  font-family: unset;
  font-weight: bolder;
  justify-content: center;
  /* display: flex; */
  align-items: center;
}
.precent{
  font-weight: bolder;
  font-size: 60px;
  color: white;
  z-index: +1;
  position: relative;
  /* top: 50%; */
  /* left: 50%; */
  transform: translate(0%, -200px);
}
.col{
  min-width: 320px;
}

.info{
  display: flex;
  justify-content: center;
  font-size: 25px;
  font-weight: bolder;
  background-color: burlywood !important;
  border-radius: 40px;
}

.BtnDiv{
  display: flex;
  justify-content: center;
  align-items: center;
  gap:10px
}
.counter{
  color: forestgreen;
  font-weight: bold;
  margin-bottom: -10px;
}
.separate{
  height: 10px;
}
.delete{
  font-size: 25px;
  padding: 2%;
  border-radius: 10px;
  width:60% ;
  border:none;
  
  background-color: rgb(128, 0, 0);
  /* box-shadow: #766744 7px 4px; */
  color: white;
}
.Button{
  font-size: 25px;
  padding: 2%;
  border-radius: 10px;
  width:60% ;
  border:none;
  
  background-color: forestgreen;
  /* box-shadow: #766744 7px 4px; */
  color: white;
}

.ButtonDiv{
  margin-top: -100px;
  padding-bottom: 5%;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;;GAEG;AACH;EACE,WAAW;EACX,aAAa;EACb,6CAA6C;EAC7C,gBAAgB;;EAEhB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,UAAU;EACV,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;;EAEjB,YAAY;EACZ,sCAAsC;EACtC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;IACI,2BAA2B;IAC3B,kCAAkC;IAClC,kBAAkB;IAClB,sCAAsC;IACtC,iBAAiB;;IAEjB,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;IACtB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,sCAAsC;EACtC,iBAAiB;;EAEjB,YAAY;EACZ,sCAAsC;EACtC,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,WAAW;;EAEX,gCAAgC;EAChC,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,WAAW;;EAEX,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n} \n\n/* body{\n   background-color: antiquewhite; \n} */\nheader{\n  color: grey;\n  display: flex;\n  /* background-color: whitesmoke !important; */\n  /* height: 0%; */\n \n  flex-direction: column;\n  align-items: center;\n}\n.modal-header{\n  justify-content: center;\n}\n.modal-body{\n  text-align: center;\n}\n.bodyApp {\n  display: flex;\n  /* width: 100vw; */\n  height: 55vh;\n  align-items: center;\n  justify-content: center;\n}\n.header{\n  margin-top: 5%;\n}\n.title{\n  font-size: 40px;\n  font-family: inherit;\n  font-weight: 900;\n}\n.Ocean {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 90%;\n  height: 90%;\n  border-radius: 0px 10px 10px 0px;\n  background-color: #B3E5FC !important;\n  overflow: hidden;\n  border-radius: 50px;\n}\n.Ocean_disabled {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  width: 90%;\n  height: 90%;\n  border-radius: 0px 10px 10px 0px;\n  background-color: #B3E5FC !important;\n  overflow: hidden;\n  border-radius: 50px;\n}\n\n.Button:disabled{\n  background-color: gray;\n}\n.Level100{\n  transform: translateY(-1px);\n  background: rgb(128, 0, 0) !important;\n  /* padding: 0px; */\n  /* border-radius: 50px 50px 0px 0px; */\n  /* margin: 0px; */\n \n  border: none;\n  /* box-shadow: grey 0px 0px 0px 5px; */\n  /* margin-top: -10%; */\n  color: white;\n  font-size: 50px;\n  font-family: unset;\n  font-weight: bolder;\n  justify-content: center;\n  /* display: flex; */\n  align-items: center;\n}\n.Level{\n    transform: translateY(-1px);\n    background: forestgreen !important;\n    /* padding: 0px; */\n    /* border-radius: 50px 50px 0px 0px; */\n    /* margin: 0px; */\n   \n    border: none;\n    /* box-shadow: grey 0px 0px 0px 5px; */\n    /* margin-top: -10%; */\n    color: white;\n    font-size: 50px;\n    font-family: unset;\n    font-weight: bolder;\n    justify-content: center;\n    /* display: flex; */\n    align-items: center;\n}\n.Level_disabled{\n  transform: translateY(-1px);\n  background: grey !important;\n  /* padding: 0px; */\n  /* border-radius: 50px 50px 0px 0px; */\n  /* margin: 0px; */\n \n  border: none;\n  /* box-shadow: grey 0px 0px 0px 5px; */\n  /* margin-top: -10%; */\n  color: white;\n  font-size: 50px;\n  font-family: unset;\n  font-weight: bolder;\n  justify-content: center;\n  /* display: flex; */\n  align-items: center;\n}\n.precent{\n  font-weight: bolder;\n  font-size: 60px;\n  color: white;\n  z-index: +1;\n  position: relative;\n  /* top: 50%; */\n  /* left: 50%; */\n  transform: translate(0%, -200px);\n}\n.col{\n  min-width: 320px;\n}\n\n.info{\n  display: flex;\n  justify-content: center;\n  font-size: 25px;\n  font-weight: bolder;\n  background-color: burlywood !important;\n  border-radius: 40px;\n}\n\n.BtnDiv{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap:10px\n}\n.counter{\n  color: forestgreen;\n  font-weight: bold;\n  margin-bottom: -10px;\n}\n.separate{\n  height: 10px;\n}\n.delete{\n  font-size: 25px;\n  padding: 2%;\n  border-radius: 10px;\n  width:60% ;\n  border:none;\n  \n  background-color: rgb(128, 0, 0);\n  /* box-shadow: #766744 7px 4px; */\n  color: white;\n}\n.Button{\n  font-size: 25px;\n  padding: 2%;\n  border-radius: 10px;\n  width:60% ;\n  border:none;\n  \n  background-color: forestgreen;\n  /* box-shadow: #766744 7px 4px; */\n  color: white;\n}\n\n.ButtonDiv{\n  margin-top: -100px;\n  padding-bottom: 5%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
